// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../img/load.gif");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    margin: 0;
}

body {
    position: relative;
}

.igsWaitMask {
    position:fixed !important;
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    z-index: 9999;
    background-color: white;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center 200px;
    opacity: 0.6;
}

.igsWaitMaskHidden {
    display: none;
}

.modal-dialog {
    width: 80%;
    /*width: 800px;*/  
}

.modal-content p {
    overflow-wrap: break-word;
}`, "",{"version":3,"sources":["webpack://./src/Common/css/igsWaitMask.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,KAAK;IACL,OAAO;IACP,QAAQ;IACR,MAAM;IACN,aAAa;IACb,uBAAuB;IACvB,yDAAsC;IACtC,4BAA4B;IAC5B,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["html, body {\r\n    margin: 0;\r\n}\r\n\r\nbody {\r\n    position: relative;\r\n}\r\n\r\n.igsWaitMask {\r\n    position:fixed !important;\r\n    position:absolute;\r\n    top:0;\r\n    right:0;\r\n    bottom:0;\r\n    left:0;\r\n    z-index: 9999;\r\n    background-color: white;\r\n    background-image: url(../img/load.gif);\r\n    background-repeat: no-repeat;\r\n    background-position: center 200px;\r\n    opacity: 0.6;\r\n}\r\n\r\n.igsWaitMaskHidden {\r\n    display: none;\r\n}\r\n\r\n.modal-dialog {\r\n    width: 80%;\r\n    /*width: 800px;*/  \r\n}\r\n\r\n.modal-content p {\r\n    overflow-wrap: break-word;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
